import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill={color} fillRule="nonzero">
            <path d="M8.022 12.843a1.015 1.015 0 0 0-1.408 0 .953.953 0 0 0 0 1.371l4.587 4.47c.194.19.437.284.704.284h.049a1.12 1.12 0 0 0 .728-.355l11.48-13.41a.98.98 0 0 0-.121-1.37 1.043 1.043 0 0 0-1.408.117l-10.8 12.606-3.811-3.713z"/>
            <path d="M21.392 2.139C15.842-1.331 8.723-.512 4.09 4.115c-5.453 5.447-5.453 14.34 0 19.788a13.99 13.99 0 0 0 19.787 0c4.658-4.652 5.454-11.786 1.955-17.33a.981.981 0 0 0-1.665 1.037c3.016 4.772 2.317 10.894-1.69 14.895-4.68 4.676-12.33 4.676-17.011 0-4.682-4.676-4.682-12.316 0-16.992C9.47 1.536 15.576.837 20.354 3.802a.981.981 0 0 0 1.038-1.663z"/>
        </g>
    </svg>
)

export default class IconFieldCheckbox extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
